export const pattern22Data = [
  {
    koreanChunks: ["이 접근법은 더 효과적이다", "우리가 작년에 사용한 것보다"],
    englishChunks: [
      "This approach is more effective",
      "than the one we used last year",
    ],
    fullEnglish:
      "This approach is more effective than the one we used last year.",
    additionalExplanation:
      "형용사에 -er를 붙여서 비교급으로 표현하기도 하지만 이렇게 형용사는 그대로 두고 more를 붙여서 어떤 것이 더 한 상태를 표현하기도 합니다.",
  },
  {
    koreanChunks: ["개정된 정책은 덜 복잡하다", "원래 정책보다"],
    englishChunks: [
      "The revised policy is less complicated",
      "than the original one",
    ],
    fullEnglish:
      "The revised policy is less complicated than the original one.",
    additionalExplanation:
      "비교급을 표현할 때 'less + 형용사'를 사용하여 '덜 ~하다'라는 의미를 나타낼 수 있습니다. 여기서는 'less complicated'로 '덜 복잡하다'를 표현했습니다.",
  },
  {
    koreanChunks: [
      "직원들이 이제 일을 하고 있다 더 효율적으로",
      "새로운 시스템과 함께 ",
    ],
    englishChunks: [
      "Employees are now working more efficiently",
      "with the new system",
    ],
    fullEnglish:
      "Employees are now working more efficiently with the new system.",
    additionalExplanation:
      "부사가 더 / 덜 ~ 한 상태를 표현하기 위해서 more, less를 사용합니다.",
  },
  {
    koreanChunks: ["이 옵션은 훨씬 더 저렴하다", "대안보다"],
    englishChunks: ["This option is much cheaper", "than the alternative"],
    fullEnglish: "This option is much cheaper than the alternative.",
    additionalExplanation:
      "비교급을 더 강조해서 말하고 싶을 때 원어민들은 much를 사용합니다. 저렴하긴 한데 훨씬 더 저렴하다고 하고 싶을 때 사용합니다. ",
  },
  {
    koreanChunks: ["업데이트된 일정은 ", "약간 더 유연하다"],
    englishChunks: ["The updated schedule is", "slightly more flexible"],
    fullEnglish: "The updated schedule is slightly more flexible.",
    additionalExplanation:
      "비교급 앞에 'slightly'를 사용하여 '약간 더'라는 의미를 표현합니다. 'more + 형용사' 구조로 비교급을 만들고, 정도를 나타내는 부사 'slightly'로 그 정도가 작음을 나타냅니다.",
  },
  {
    koreanChunks: ["그들의 서비스는 훨씬 더 좋다", "이전보다"],
    englishChunks: ["Their service is far better", "than before"],
    fullEnglish: "Their service is far better than before.",
    additionalExplanation:
      "비교급을 강조하기 위해 'far'를 사용하여 '훨씬 더 좋다'라는 의미를 표현합니다. 'good'의 비교급인 'better'와 함께 사용되어 이전 상태와 비교하여 현재 서비스의 품질이 크게 향상되었음을 나타냅니다.",
  },
  {
    koreanChunks: ["새 제품은 신뢰할 수 있다", "이전 버전만큼"],
    englishChunks: ["The new product is as reliable", "as the older version"],
    fullEnglish: "The new product is as reliable as the older version.",
    additionalExplanation:
      "우리도 ~ 만큼 어떻다라고 말하고 싶을 때 ~ 만큼을 사용하듯 as를 원어민도 사용합니다. ",
  },
  {
    koreanChunks: ["그 새 서버는 2배 만큼 빠르다", "이전 것보다"],
    englishChunks: [
      "The new server is two times as fast",
      "as the previous one",
    ],
    fullEnglish: "The new server is two times as fast as the previous one.",
    additionalExplanation:
      "배수 표현을 할 때 'two times/three times/four times + as + 형용사 + as' 구조를 사용합니다. '두 배 더 빠르다'라는 의미를 'two times as fast as'로 표현하여 새 서버와 이전 서버의 속도를 비교하고 있습니다.",
  },
  {
    koreanChunks: ["그들의 수익은 3배 더 높다", "우리 것보다"],
    englishChunks: ["Their revenue is three times higher", "than ours"],
    fullEnglish: "Their revenue is three times higher than ours.",
    additionalExplanation:
      "배수 표현을 할 때 'three times + 비교급(higher)' 구조를 사용합니다. '세 배 더 높다'라는 의미를 'three times higher than'으로 표현하여 그들의 수익과 우리의 수익을 비교하고 있습니다. 배수 표현은 'X times as + 형용사 + as' 또는 'X times + 비교급 + than' 두 가지 방식으로 표현할 수 있습니다.",
  },
  {
    koreanChunks: ["시스템이 되어지는 중이다", "더 빠르게 그리고 더 빠르게"],
    englishChunks: ["The system is becoming faster and faster"],
    fullEnglish: "The system is becoming faster and faster.",
    additionalExplanation:
      "점진적인 변화나 증가를 표현할 때 'faster and faster'와 같이 같은 비교급을 반복해서 사용합니다. 이는 '점점 더 ~해지다'라는 의미를 전달하며, 'becoming'과 함께 사용하여 지속적인 변화를 강조합니다.",
  },
  {
    koreanChunks: ["이 프린터는 훨씬 더 빠르다", "옛날 모델보다"],
    englishChunks: ["This printer is a lot faster", "than the old model"],
    fullEnglish: "This printer is a lot faster than the old model.",
    additionalExplanation:
      "비교급을 강조하기 위해 'a lot'을 사용하여 '훨씬 더 빠르다'라는 의미를 표현합니다. ",
  },
  {
    koreanChunks: ["수정된 예산은 상당히 더 낮다", "예상했던 것보다"],
    englishChunks: [
      "The revised budget is considerably lower",
      "than expected",
    ],
    fullEnglish: "The revised budget is considerably lower than expected.",
    additionalExplanation:
      "비교급을 강조하기 위해 'considerably'를 사용하여 '상당히 더 낮다'라는 의미를 표현합니다. ",
  },
  {
    koreanChunks: ["이것은 최고의 솔루션이다.", "그.. 우리가 받은 지금까지"],
    englishChunks: ["This is the best solution", "we've received so far"],
    fullEnglish: "This is the best solution we've received so far.",
    additionalExplanation:
      "'the best'는 'good'의 최상급 형태로, '최고의'라는 말을 할 때 사용합니다.",
  },
  {
    koreanChunks: ["참조하세요 가장 최신의 버전 서류."],
    englishChunks: ["Please refer ", "to the latest version of the document."],
    fullEnglish: "Please refer to the latest version of the document.",
    additionalExplanation:
      "가장 최신이라는 말을 하려면 the latest를 사용합니다.",
  },

  {
    koreanChunks: [
      "이것은 가장 효율적인 방법이다",
      "우리가 시도한 모든 것 중에서",
    ],
    englishChunks: ["This is the most efficient method", "of all we've tried"],
    fullEnglish: "This is the most efficient method of all we've tried.",
    additionalExplanation:
      "'the most + 형용사'는 최상급 형태로, '가장 ~한'이라는 의미를 표현합니다. 원어민들이 형용사를 최상급으로, 즉 가장 ~한이라고 말하고 싶을 때는 the most를 사용합니다.",
  },
  {
    koreanChunks: ["이것은 가장 덜 비싼 제품이다", "우리가 제공하는"],
    englishChunks: ["This is the least expensive model", "we offer"],
    fullEnglish: "This is the least expensive model we offer.",
    additionalExplanation:
      "'the least + 형용사'는 최상급 형태로, '가장 덜 ~한'이라는 의미를 표현합니다. 'expensive'(비싼)의 최상급 형태로 'the least expensive'는 '가장 저렴한'을 의미합니다.",
  },
  {
    koreanChunks: ["이것은 가장 정확한 것이다", "세 가지 제안 중"],
    englishChunks: ["This is the most accurate", "of the three proposals"],
    fullEnglish: "This is the most accurate of the three proposals.",
    additionalExplanation:
      "'of the three proposals'는 비교 대상을 명확히 하여 '세 가지 제안 중에서'라는 의미를 나타냅니다.",
  },
  {
    koreanChunks: ["그는 한명이다", "가장 뛰어난 디자이너중", "회사에서"],
    englishChunks: ["He is one", " of the best designers ", "in the company."],
    fullEnglish: "He is one of the best designers in the company.",
    additionalExplanation:
      "'one of the best'는 '가장 뛰어난 것들 중 하나'라는 의미로, 최상급 표현과 함께 사용됩니다. 'the best'는 'good'의 최상급 형태로 '가장 좋은, 가장 뛰어난'을 의미합니다.",
  },
  {
    koreanChunks: ["그녀는 한명이다", "가장 존경받는 매니저들 중", "여기서"],
    englishChunks: ["She is one", " of the most respected managers ", "here"],
    fullEnglish: "She is one of the most respected managers here.",
    additionalExplanation:
      "'one of the most'는 '가장 ~한 것들 중 하나'라는 의미로, 최상급 표현과 함께 사용됩니다. 'respected'는 '존경받는'이라는 의미로, 'the most respected'는 '가장 존경받는'을 의미합니다.",
  },
  {
    koreanChunks: ["이것은 단연코 가장 인기있는 제품이다", "올해"],
    englishChunks: ["This is by far the most popular product", " this year."],
    fullEnglish: "This is by far the most popular product this year.",
    additionalExplanation:
      "'by far'는 '단연코, 압도적으로'라는 의미로, 최상급 표현을 강조할 때 사용합니다.",
  },
  {
    koreanChunks: ["이것은 단연코 최고의 해결책이다", "우리가 테스트한"],
    englishChunks: ["It's easily the best solution", "we've tested"],
    fullEnglish: "It's easily the best solution we've tested.",
    additionalExplanation:
      "'easily'는 '단연코, 쉽게'라는 의미로, 최상급 표현을 강조할 때 사용합니다. 'the best'는 'good'의 최상급 형태로 '가장 좋은, 최고의'를 의미합니다.",
  },
  {
    koreanChunks: ["새 인턴은 ~중 가장 뛰어났다", "우리가 고용한 인턴 중에"],
    englishChunks: ["The new intern is among the best", "we've hired"],
    fullEnglish: "The new intern is among the best we've hired.",
    additionalExplanation:
      "'among the best'는 '가장 뛰어난 사람들 중에'라는 의미로, 최상급 표현과 함께 사용됩니다. 'the best'는 '가장 뛰어난, 최고의'를 의미하며, 'among'은 '~중에'라는 의미로 여러 대상 중 하나임을 나타냅니다.",
  },
  {
    koreanChunks: ["이것은 가장 성공적인 캠페인이다", "회사가 지금까지 출시한"],
    englishChunks: [
      "This is the most successful campaign",
      "the company has ever launched",
    ],
    fullEnglish:
      "This is the most successful campaign the company has ever launched.",
    additionalExplanation:
      "'the most successful'은 'successful'의 최상급 형태로 '가장 성공적인'이라는 의미입니다. 'ever'는 '지금까지, 이제까지'라는 의미로 과거부터 현재까지의 시간을 강조하며, 'has ever launched'는 현재완료 시제로 '지금까지 출시한'이라는 의미를 나타냅니다.",
  },
  {
    koreanChunks: ["이것은 지금까지 최고의 성과이다", "올해 지금까지"],
    englishChunks: ["This is the best performance", " so far this year."],
    fullEnglish: "This is the best performance so far this year.",
    additionalExplanation:
      "'the best'는 'good'의 최상급 형태로 '가장 좋은, 최고의'를 의미합니다. 'so far'는 '지금까지'라는 의미로, 현재까지의 시간을 강조할 때 사용합니다. 이 문장은 '이것은 올해 지금까지 최고의 성과이다'라는 의미를 나타냅니다.",
  },
];
